// 超輕量的全域狀態（不引入外部狀態庫）。
// 供三頁流程共用：建立案件 -> 上傳 -> 分析。
// 支援資料持久化，頁面刷新後資料不丟失

import { reactive, watch } from 'vue'
import persistentStorage from '../utils/persistentStorage.js'

// 從localStorage載入資料，如果沒有則使用預設值
function loadFromStorage() {
    // 先嘗試從新的持久化儲存載入
    const storedCaseData = persistentStorage.loadCaseData()
    if (Object.keys(storedCaseData).length > 0) {
        return {
            id: storedCaseData.id || '',
            projectName: storedCaseData.projectName || '',
            caseDate: storedCaseData.caseDate || '',
            details: storedCaseData.details || {
                mountainName: [],
                route: [],
                climbingStyle: [],
                county: []
            },
            uploads: storedCaseData.uploads || {
                gpxFileNames: [],
                excelFile: null,
                kmzFile: null
            },
            ipp: storedCaseData.ipp || { lon: '', lat: '' },
            analysisRadiusKm: storedCaseData.analysisRadiusKm || ''
        }
    }

    // 如果沒有新格式資料，嘗試載入舊格式
    const stored = localStorage.getItem('caseStore')
    if (stored) {
        try {
            return JSON.parse(stored)
        } catch (e) {
            console.warn('Failed to parse stored case data:', e)
        }
    }
    
    return {
        id: '',
        projectName: '',
        caseDate: '',
        details: {
            mountainName: [],
            route: [],
            climbingStyle: [],
            county: []
        },
        uploads: {
            gpxFileNames: [],
            excelFile: null,
            kmzFile: null
        },
        ipp: { lon: '', lat: '' },
        analysisRadiusKm: ''
    }
}

export const caseStore = reactive(loadFromStorage())

// 監聽資料變化，自動保存到localStorage
watch(
    caseStore,
    (newValue) => {
        // 同時保存到新舊兩種格式
        localStorage.setItem('caseStore', JSON.stringify(newValue))
        persistentStorage.saveCaseData(newValue)
    },
    { deep: true }
)

// 重置所有資料到初始狀態
export function resetCaseStore() {
    const defaultData = {
        id: '',
        projectName: '',
        caseDate: '',
        details: {
            mountainName: [],
            route: [],
            climbingStyle: [],
            county: []
        },
        uploads: {
            gpxFileNames: [],
            excelFile: null,
            kmzFile: null
        },
        ipp: { lon: '', lat: '' },
        analysisRadiusKm: ''
    }
    
    // 清空所有儲存
    localStorage.removeItem('caseStore')
    persistentStorage.clearAll()
    
    // 重置reactive對象
    Object.assign(caseStore, defaultData)
}

export function generateCaseId() {
    const d = new Date()
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    const rnd = Math.random().toString(36).substr(2, 5).toUpperCase()
    return `CASE-${y}${m}${dd}-${rnd}`
}


